module.exports = __webpack_public_path__ + "img/img-login-1.05b22bc3.png";